module.exports = __webpack_public_path__ + "img/b2cshangcheng1.837933e7.png";